import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { useSelector } from 'react-redux';

import { routesWithPerms } from '../Main';
import GeneralProgressBar from '../GeneralProgressBar';

export const Fallback = (<GeneralProgressBar />);

function checkPermissions(auth, accessPerm, perms) {
    if (!auth) return false;

    if (!accessPerm || accessPerm === 'ALLOW_ALL') return true;

    return perms.some(p => accessPerm.some(a => a.value === p.value));
}

export default function ProtectedRoute({
    children,
    pathKey,
    redirectTo = '/',
    requirePerms = true,
}) {
    const { keycloak } = useKeycloak();
    const location = useLocation();
    const perms = useSelector(state => state.user.perms) || [];

    if (requirePerms && !perms.length) {
        return Fallback;
    }

    let accessPerm = 'ALLOW_ALL';
    if (requirePerms && pathKey) {
        accessPerm = routesWithPerms.find(r => r.path === pathKey)?.perm;
    }

    const allowed = checkPermissions(keycloak.authenticated, accessPerm, perms);

    if (!allowed) {
        return (
            <Navigate
                to={redirectTo}
                replace
                state={{ from: location }}
            />
        );
    }

    return <React.Suspense fallback={(<GeneralProgressBar />)}>{children}</React.Suspense>;
}
